module.exports = __webpack_public_path__ + "img/1944-paris-gold.a5fb2878.png";